module.exports = __webpack_public_path__ + "static/media/office-green-map.b30bcba0.png";